<template>
    <div class="h-full">
        <dashboard v-if="authenticated"></dashboard>
        <LP2></LP2>
<!--        <landing v-else></landing>-->
    </div>

</template>

<script>
    // import Landing from '../pages/landing/Landing'
    import Dashboard from '../views/Dashboard'
    import * as fb from '../firebaseConfig'
    import LP2 from "@/pages/landing/LP2";
    export default {
        name: "Home",
        components: {
            LP2,
            dashboard: Dashboard,
            // landing: Landing
        },
        computed: {
            usedComponent(){
                return (fb.auth.currentUser ? this.dashboard : this.landing)
            },
            authenticated(){
                return (!!fb.auth.currentUser)
            }
        }
    }
</script>

<style scoped>

</style>
